module.exports = "<div class=\"container\">\n  <div class=\"swagger-container\">\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/api-docs/api-docs.component.html
// module id = xpsF
// module chunks = 0